import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import CouponProviderActions from '../../Redux/CouponProviderRedux'
import CouponPresetActions from '../../Redux/CouponPresetRedux'
import CreateProvider from '../../Containers/Coupon/CreateProvider'
import UpdateProvider from '../../Containers/Coupon/UpdateProvider'
import DeleteProvider from '../../Containers/Coupon/DeleteProvider'
import CreatePreset from '../../Containers/Coupon/CreatePreset'
import UpdatePreset from '../../Containers/Coupon/UpdatePreset'
import DeletePreset from '../../Containers/Coupon/DeletePreset'

class ManageProvider extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedProvider: null,
      tab: 'Provider',
      showModal: null,
      detail: {}
    }
  }

  componentDidMount = () => {
    this._customFetch()
  }

  _customFetch = () => {
    if (this.state.tab === 'Provider') {
      this.props.getCouponProvider()
    } else if (this.state.tab === 'Preset') {
      this.props.getCouponPreset()
    }
  }

  _toggleModal = (modalID = null) => {
    this.setState({ showModal: modalID })
    if (!modalID) {
      setTimeout(() => {
        this._customFetch()
      }, 100)
    }
  }

  _resetSelector = (item) => {
    item.provider_id === null
      ? this.setState({ selectedProvider: null })
      : this.setState({
        selectedProvider: {
          value: item.coupon_providers ? item.coupon_providers.id : '',
          label: item.coupon_providers ? item.coupon_providers.name : ''
        }
      })
  }

  _selectItem = (item, action) => {
    if (action === 'update-preset') {
      this._resetSelector(item)
    }
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _changeTab = (tab) => {
    this.setState({ tab })
    setTimeout(() => {
      this._customFetch()
    }, 100)
  }

  render () {
    const { couponProvider, couponPreset } = this.props

    return (
      <section className='section'>
        <div className='title-block d-flex mb-3 justify-content-between'>
          <h1 className='title mr-auto'>
            Manage {this.state.tab}
            {
              (couponProvider.fetching || couponProvider.processing || couponPreset.fetching || couponPreset.processing) &&
              <div className='badge badge-info ml-2'>Loading ...</div>
            }
          </h1>
          {
            this.state.tab === 'Provider'
              ? !(couponProvider.fetching || couponProvider.processing) && couponProvider.err &&
                <div className='alert alert-danger'>{couponProvider.err}</div>
              : !(couponPreset.fetching || couponPreset.processing) && couponPreset.err &&
                <div className='alert alert-danger'>{couponProvider.err}</div>
          }
          {
            this.state.tab === 'Provider'
              ? <button className='btn btn-primary' onClick={() => this._toggleModal('create-provider')}>Create Provider</button>
              : <button className='btn btn-primary' onClick={() => this._toggleModal('create-preset')}>Create Preset</button>
          }
        </div>
        <div className='btn-group mb-3' role='group'>
          <button className={`btn btn-primary ${this.state.tab === 'Provider' && 'active'}`} onClick={() => this._changeTab('Provider')}>Provider</button>
          <button className={`btn btn-primary ${this.state.tab === 'Preset' && 'active'}`} onClick={() => this._changeTab('Preset')}>Preset</button>
        </div>
        {
          this.state.tab === 'Provider' &&
          <section className='section'>
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th className='text-center'>Name</th>
                  <th className='text-center'>Edit</th>
                  <th className='text-center'>Delete</th>
                </tr>
              </thead>
              <tbody>
                {
                  couponProvider.data
                    ? couponProvider.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center'>{item.name}</td>
                        <td className='text-center'>
                          <button className='btn btn-primary' onClick={() => this._selectItem(item, 'update-provider')}>
                            <i className='fa fa-edit' /> Edit
                          </button>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-provider')}>
                            <i className='fa fa-trash' />
                          </button>
                        </td>
                      </tr>
                    ))
                    : <tr>
                      <td className='text-center' colSpan='3'>-- No Data --</td>
                    </tr>
                }
              </tbody>
            </table>
          </section>
        }
        {
          this.state.tab === 'Preset' &&
          <section className='section'>
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th className='text-center'>Card Type</th>
                  <th className='text-center'>Provider Name</th>
                  <th className='text-center'>Prefix</th>
                  <th className='text-center'>Edit</th>
                  <th className='text-center'>Delete</th>
                </tr>
              </thead>
              <tbody>
                {
                  couponPreset.data
                    ? couponPreset.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center'>{item.card_type}</td>
                        <td className='text-center'>{item.coupon_providers ? item.coupon_providers.name : '-- No Data --'}</td>
                        <td className='text-center'>{item.prefix}</td>
                        <td className='text-center'>
                          <button className='btn btn-primary' onClick={() => this._selectItem(item, 'update-preset')}>
                            <i className='fa fa-edit' />
                          </button>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-preset')}>
                            <i className='fa fa-trash' />
                          </button>
                        </td>
                      </tr>
                    ))
                    : <tr>
                      <td className='text-center' colSpan='5'>-- No Data --</td>
                    </tr>
                }
              </tbody>
            </table>
          </section>
        }

        {/* CREATE PROVIDER MODAL */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-provider'} onClose={() => this._toggleModal()}>
          <CreateProvider closeModal={() => this._toggleModal()} />
        </Modal>

        {/* UPDATE PROVIDER MODAL */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-provider'} onClose={() => this._toggleModal()}>
          <UpdateProvider detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* DELETE PROVIDER MODAL */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'delete-provider'} onClose={() => this._toggleModal()}>
          <DeleteProvider detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* CREATE PRESET MODAL */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-preset'} onClose={() => this._toggleModal()}>
          <CreatePreset closeModal={() => this._toggleModal()} />
        </Modal>

        {/* UPDATE PRESET MODAL */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-preset'} onClose={() => this._toggleModal()}>
          <UpdatePreset selectedProvider={this.state.selectedProvider} detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* DELETE PRESET MODAL */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'delete-preset'} onClose={() => this._toggleModal()}>
          <DeletePreset detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

      </section>
    )
  }
}

const stateToProps = (state) => ({
  couponProvider: state.couponProvider,
  couponPreset: state.couponPreset
})

const dispatchToProps = (dispatch) => ({
  getCouponProvider: (data) => dispatch(CouponProviderActions.getCouponProviderRequest(data)),
  getCouponPreset: (data) => dispatch(CouponPresetActions.getCouponPresetRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ManageProvider)



// WEBPACK FOOTER //
// ./src/Pages/Coupon/ManageProvider.js